<template>
  <div class="pa-4 mt-8">© {{ year }} {{ name }}, All rights reserved.</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',

  components: {},

  data() {
    return {
      year: ''
    };
  },

  computed: {
    name() {
      return this.master_account.name;
    },

    ...mapGetters({ master_account: 'user/master_account' })
  },

  mounted() {
    this.year = new Date().getFullYear();
  },

  methods: {}
};
</script>

<style></style>
